import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);

    const modalElement = document.getElementById("successModal");

    if (!modalElement || !window.bootstrap) {
        alert(message);
        return;
    }

    const modal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
    modal.show();
}

// Hide modal safely
function hideModal(modalId) {
    const modalElement = document.getElementById(modalId);

    if (modalElement && window.bootstrap) {
        const modal = window.bootstrap.Modal.getInstance(modalElement);

        if (modal) {
            modal.hide();
        }
    }
}

// Fetch and display all client reviews
function loadAllClientReviews() {
    $.ajax({
        url: `${API_BASE_URL}/api/client/all`,
        type: "GET",

        success: function (clients) {
            const reviews = Array.isArray(clients) ? [...clients].reverse() : [];

            let rows = "";

            reviews.forEach((client, index) => {
                const imageUrl = client.image
                    ? `${API_BASE_URL}/assets/Images/${encodeURIComponent(client.image)}`
                    : "";

                rows += `
                    <tr>
                        <td>${index + 1}</td>

                        <td>
                            ${
                                imageUrl
                                    ? `<img
                                        src="${imageUrl}"
                                        width="80"
                                        height="80"
                                        alt="Client logo"
                                        style="object-fit: contain;"
                                    />`
                                    : "No image"
                            }
                        </td>

                        <td>${escapeHtml(client.companyName)}</td>
                        <td>${escapeHtml(client.product)}</td>
                        <td>${escapeHtml(client.description)}</td>

                        <td>
                            <button
                                type="button"
                                class="btn btn-primary btn-sm editBtn"
                                data-id="${Number(client.id)}"
                            >
                                Edit
                            </button>

                            <button
                                type="button"
                                class="btn btn-danger btn-sm mx-1 deleteClientReview"
                                data-id="${Number(client.id)}"
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                `;
            });

            $("#allClientsData").html(
                rows || `
                    <tr>
                        <td colspan="6" class="text-center">
                            No client reviews available.
                        </td>
                    </tr>
                `
            );
        },

        error: function (xhr) {
            console.error("Failed to fetch Client Review", xhr);
        }
    });
}

// Escape API text before inserting it into HTML
function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, function (character) {
        const entities = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };

        return entities[character];
    });
}

// Expose the existing list-loading function to React
window.loadClientReviews = function () {
    loadAllClientReviews();
};

// Explicitly initialize handlers when the React component mounts
function initializeClientReviewHandlers() {
    const $addForm = $("#addClientForm");
    const $editForm = $("#editClientForm");

    // ADD CLIENT REVIEW
    $addForm
        .off("submit.clientReview")
        .on("submit.clientReview", function (e) {
            e.preventDefault();

            const formElement = this;
            const imageInput = $("#image")[0];

            const formData = new FormData();

            formData.append("companyName", $("#companyName").val());
            formData.append("product", $("#product").val());
            formData.append("description", $("#discription").val());

            if (imageInput && imageInput.files.length > 0) {
                formData.append("image", imageInput.files[0]);
            }

            $.ajax({
                url: `${API_BASE_URL}/api/client/add`,
                type: "POST",
                data: formData,
                contentType: false,
                processData: false,

                success: function () {
                    formElement.reset();

                    hideModal("clientModal");
                    loadAllClientReviews();

                    showSuccessModal("Client Review Added Successfully!");
                },

                error: function (xhr) {
                    console.error("Failed to add Client Review", {
                        status: xhr.status,
                        response: xhr.responseText
                    });

                    alert("Failed to add Client Review!");
                }
            });
        });

    // OPEN EDIT MODAL
    $(document)
        .off("click.clientReview", ".editBtn")
        .on("click.clientReview", ".editBtn", function () {
            const id = $(this).data("id");

            $.ajax({
                url: `${API_BASE_URL}/api/client/get/${id}`,
                type: "GET",

                success: function (client) {
                    $("#editId").val(client.id);
                    $("#editCompanyName").val(client.companyName);
                    $("#editProduct").val(client.product);
                    $("#editDescription").val(client.description);
                    $("#editImage").val("");

                    const modalElement =
                        document.getElementById("editClientModal");

                    if (modalElement && window.bootstrap) {
                        window.bootstrap.Modal
                            .getOrCreateInstance(modalElement)
                            .show();
                    }
                },

                error: function (xhr) {
                    console.error("Failed to fetch client", xhr);
                }
            });
        });

    // UPDATE CLIENT REVIEW
    $editForm
        .off("submit.clientReview")
        .on("submit.clientReview", function (e) {
            e.preventDefault();

            const id = $("#editId").val();
            const imageInput = $("#editImage")[0];

            const formData = new FormData();

            formData.append("name", $("#editCompanyName").val());
            formData.append("product", $("#editProduct").val());
            formData.append("description", $("#editDescription").val());

            if (imageInput && imageInput.files.length > 0) {
                formData.append("image", imageInput.files[0]);
            }

            $.ajax({
                url: `${API_BASE_URL}/api/client/update/${id}`,
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,

                success: function () {
                    hideModal("editClientModal");
                    loadAllClientReviews();

                    showSuccessModal("Client Review Updated Successfully!");
                },

                error: function (xhr) {
                    console.error("Failed to update client review", {
                        status: xhr.status,
                        response: xhr.responseText
                    });

                    alert("Failed to update client review");
                }
            });
        });

    // DELETE CLIENT REVIEW
    $(document)
        .off("click.clientReview", ".deleteClientReview")
        .on("click.clientReview", ".deleteClientReview", function () {
            const id = $(this).data("id");

            if (!window.confirm(
                "Are you sure you want to delete this Client Review?"
            )) {
                return;
            }

            $.ajax({
                url: `${API_BASE_URL}/api/client/delete/${id}`,
                type: "DELETE",

                success: function () {
                    loadAllClientReviews();

                    showSuccessModal(
                        "Client Review Delete Successfully!"
                    );
                },

                error: function (xhr) {
                    console.error("Failed to delete Client Review", xhr);
                    alert("Failed to delete Client Review!");
                }
            });
        });
}

// Expose initialization function to React
window.initializeClientReviewHandlers =
    initializeClientReviewHandlers;



// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// // ✅ MOVE FUNCTION OUTSIDE
// function loadAllClientReviews() {
//     $.ajax({
//         url: `${API_BASE_URL}/api/client/all`,
//         type: "GET",
//         success: function (clients) {
//             clients.reverse();
//             let rows = "";
//             clients.forEach((client, index) => {
//                 rows += `
//                     <tr>
//                         <td>${index + 1}</td>
//                         <td><img src="${API_BASE_URL}/assets/Images/${client.image}" width="80" height="80" /></td>
//                         <td>${client.companyName}</td>
//                         <td>${client.product}</td>
//                         <td>${client.description}</td>
//                         <td>
//                             <button class="btn btn-primary btn-sm editBtn" data-id="${client.id}">Edit</button>
//                             <button class="btn btn-danger btn-sm mx-1 deleteClientReview" data-id="${client.id}">Delete</button>
//                         </td>
//                     </tr>
//                 `;
//             });
//             $("#allClientsData").html(rows);
//         },
//         error: function (xhr) {
//             console.error("Failed to fetch Client Review", xhr);
//         }
//     });
// }

// // ✅ EXPOSE TO REACT
// window.loadClientReviews = function () {
//     loadAllClientReviews();
// };

// $(document).ready(function () {

//     // Add Client
//     $("#addClientForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("companyName", $("#companyName").val());
//         formData.append("product", $("#product").val());
//         formData.append("description", $("#discription").val());
//         formData.append("image", $("#image")[0].files[0]);

//         $.ajax({
//             url: `${API_BASE_URL}/api/client/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Client Review Added Successfully!");
//                 $("#addClientForm")[0].reset();

//                 const clientModal = window.bootstrap.Modal.getInstance(document.getElementById("clientModal"));
//                 clientModal.hide();

//                 loadAllClientReviews();
//             },
//             error: function (xhr) {
//                 console.log(xhr);
//                 alert("Failed to add Client Review!");
//             }
//         });
//     });

//     // EDIT CLIENT
//     $(document).on("click", ".editBtn", function () {
//         let id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/client/get/${id}`,
//             type: "GET",
//             success: function (client) {

//                 $("#editId").val(client.id);
//                 $("#editCompanyName").val(client.companyName);
//                 $("#editProduct").val(client.product);
//                 $("#editDescription").val(client.description);

//                 const modal = new window.bootstrap.Modal(document.getElementById("editClientModal"));
//                 modal.show();
//             },
//             error: function (err) {
//                 console.log("Failed to fetch client", err);
//             }
//         });
//     });

//     $("#editClientForm").submit(function (e) {
//         e.preventDefault();

//         let id = $("#editId").val();

//         const formData = new FormData();
//         formData.append("name", $("#editCompanyName").val());
//         formData.append("product", $("#editProduct").val());
//         formData.append("description", $("#editDescription").val());

//         if ($("#editImage")[0].files.length > 0) {
//             formData.append("image", $("#editImage")[0].files[0]);
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/client/update/${id}`,
//             type: "POST",
//             data: formData,
//             processData: false,
//             contentType: false,
//             success: function () {
//                 showSuccessModal("Client Review Updated Successfully!");

//                 const modalEl = document.getElementById("editClientModal");
//                 const modal = window.bootstrap.Modal.getInstance(modalEl);
//                 modal.hide();

//                 loadAllClientReviews();
//             },
//             error: function (xhr) {
//                 alert("Failed to update client review");
//                 console.log(xhr);
//             }
//         });
//     });

//     // Delete Client
//     $(document).on("click", ".deleteClientReview", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure you want to delete this Client Review?")) {
//             return;
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/client/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Client Review Delete Successfully!");
//                 loadAllClientReviews();
//             },
//             error: function (xhr) {
//                 console.error(xhr);
//                 alert("Failed to delete Client Review!");
//             }
//         });
//     });

// });
